module.exports = __webpack_public_path__ + "static/media/wave.4e731335.svg";